
export * from "./a-b-entry.component";
export * from "./c-results-from-inputs.component";
export * from "./d-rent-deductions.component";
export * from "./e-tax-other-costs--actual-amounts.component";
export * from "./f-index-calculation-information.component";
export * from "./g-costs-with-own-index.component";
export * from "./h-calculation-rent-costs-rental-supplements.component";



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular2-router-loader/src!./TypeScript/shared/contract/ifrs/index.ts